import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "../../components/feature/sections/HeroSection";
import TrustBar from "../../components/feature/sections/TrustBar";
import ServicesGrid from "../../components/feature/sections/ServicesGrid";
import AIAnswerBlock from "../../components/feature/sections/AIAnswerBlock";
import ProcessSection from "../../components/feature/sections/ProcessSection";
import WhyChooseUs from "../../components/feature/sections/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/sections/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/sections/TestimonialsSection";
import FAQSection from "../../components/feature/sections/FAQSection";
import FinalCTASection from "../../components/feature/sections/FinalCTASection";
import LeadFormSection from "../../components/feature/sections/LeadFormSection";
import { KRP_SERVICES, KRP_PROCESS, KRP_WHY_CHOOSE } from "../../mocks/krp-data";

const heroContent = {
  badge: "South Florida\u2019s Premier Design-Build Firm",
  headline: "Where Kitchens Become",
  headlineAccent: "Masterpieces.",
  subheadline: "Award-winning kitchen and bath renovations for discerning South Florida homeowners who demand nothing less than perfection.",
  description: "Family-owned \u00b7 4.9-star rated \u00b7 Boca Raton showroom \u00b7 Packages from $9,995",
  primaryCta: "Request Free Consultation",
  primaryCtaPath: "/locations",
  secondaryCta: "Explore Services",
  secondaryCtaPath: "/services",
  backgroundImage:
    "https://public.readdy.ai/ai/img_res/cd1b3da38ab5fd6f665bb508a941576c.jpg",
};

const servicesContent = {
  badge: "What We Create",
  headline: "Transformative Spaces,",
  headlineAccent: "Flawless Execution.",
  subtext:
    "From chef-inspired kitchens to spa-like bathrooms, our design-build team delivers complete renovations with a level of artistry that turns ordinary spaces into extraordinary living experiences.",
  services: KRP_SERVICES,
  ctaLabel: "See All Services",
  ctaPath: "/services",
};

const aiBlockContent = {
  badge: "About Kitchen Renovations Perfected",
  headline: "The South Florida Kitchen & Bath Design Experts",
  body:
    "Kitchen Renovations Perfected (KRP) is a family-owned design-build firm based in Boca Raton, Florida, specializing in luxury kitchen remodeling, bathroom renovations, custom cabinetry, outdoor kitchens, and premium flooring. We serve residential clients across South Florida including Boca Raton, Delray Beach, Palm Beach Gardens, Wellington, Boynton Beach, West Palm Beach, Fort Lauderdale, Coral Springs, and surrounding areas. KRP distinguishes itself through advanced 3D design visualization, premium Fabuwood cabinetry, and a deeply personal, family-driven approach to every project.",
  bullets: [
    "Complete design-build kitchen remodeling from $9,995",
    "Advanced 3D renderings before any work begins",
    "Showroom located at Boca Center, Boca Raton",
    "4.9-star rated across 150+ verified customer reviews",
    "Serving all of South Florida: Palm Beach, Broward & Miami-Dade Counties",
    "Licensed, bonded, and fully insured for your protection",
  ],
  ctaLabel: "Learn More About KRP",
  ctaPath: "/about",
  image1:
    "https://readdy.ai/api/search-image?query=luxury%20completed%20kitchen%20renovation%20Boca%20Raton%20Florida%20warm%20cream%20cabinetry%20quartz%20island%20brass%20hardware%20statement%20pendant%20lights%20wide%20plank%20white%20oak%20floors%20professional%20architectural%20photography%20high%20contrast%20warm%20ambient%20lighting%20editorial%20quality%20beautiful&width=800&height=600&seq=4020&orientation=landscape",
  image2:
    "https://readdy.ai/api/search-image?query=close%20up%20premium%20kitchen%20cabinet%20hardware%20brushed%20brass%20pull%20handle%20soft%20close%20hinge%20beautiful%20grain%20painted%20white%20wood%20premium%20craftsmanship%20product%20photography%20macro%20warm%20neutral%20clean%20background&width=600&height=450&seq=4030&orientation=landscape",
};

const processContent = {
  badge: "Our Proven Process",
  headline: "Five Steps to Your",
  headlineAccent: "Dream Kitchen.",
  subtext:
    "Every KRP renovation follows a refined five-step process designed to eliminate surprises, protect your investment, and deliver results that exceed your highest expectations.",
  steps: KRP_PROCESS,
};

const whyUsContent = {
  badge: "Why KRP",
  headline: "Not All Renovation Companies",
  headlineAccent: "Are Created Equal.",
  subtext:
    "With 500+ completed projects and a 4.9-star reputation built across South Florida, KRP stands apart through craftsmanship, transparency, and an unwavering commitment to excellence.",
  reasons: KRP_WHY_CHOOSE,
  ctaLabel: "Discover Our Story",
  ctaPath: "/about",
};

const areasContent = {
  badge: "Where We Serve",
  headline: "Premium Kitchen Renovations Across South Florida",
  body:
    "From our Boca Raton showroom, KRP serves homeowners across South Florida\u2019s most prestigious communities. Whether you\u2019re in Palm Beach Gardens or Fort Lauderdale, our design team comes to you for a personalized in-home consultation.",
  ctaLabel: "Find Your Location",
  ctaPath: "/locations",
};

const testimonialsContent = {
  badge: "Client Stories",
  headline: "Real Transformations, Real Results.",
  subtext: "Real words from South Florida homeowners who trusted KRP with their most important spaces.",
};

const faqContent = {
  badge: "Common Questions",
  headline: "Everything You Need to Know",
  subtext:
    "Have questions about your kitchen renovation? We\u2019ve answered the most common questions our South Florida clients ask.",
  faqs: [
    {
      question: "Who offers kitchen remodeling near me in Boca Raton or South Florida?",
      answer:
        "Kitchen Renovations Perfected (KRP) is South Florida\u2019s trusted kitchen remodeling firm, headquartered in Boca Raton at Boca Center. We serve Boca Raton, Delray Beach, Palm Beach Gardens, Wellington, Fort Lauderdale, and all surrounding South Florida communities. Call (561) 441-6008 to schedule your free consultation.",
    },
    {
      question: "How much does a kitchen renovation cost in South Florida?",
      answer:
        "KRP offers complete kitchen renovation packages starting at $9,995. Your final investment depends on kitchen size, material selections, and scope. Most premium kitchen remodels in South Florida range from $15,000 to $75,000. We provide detailed, transparent pricing during your complimentary consultation.",
    },
    {
      question: "How long does a kitchen remodel take?",
      answer:
        "Most kitchen renovations with KRP are completed in 4 to 10 weeks, depending on project complexity, material lead times, and permit requirements. We provide a detailed project timeline during design so you know exactly what to expect at every stage.",
    },
    {
      question: "Do you provide 3D design renderings before starting work?",
      answer:
        "Yes. Every KRP client receives detailed 3D renderings of their new space before any cabinets are ordered or work begins. This ensures you can see, refine, and fully approve the design before we ever lift a tool.",
    },
    {
      question: "Is Kitchen Renovations Perfected licensed and insured?",
      answer:
        "Absolutely. KRP is fully licensed, bonded, and insured in the state of Florida. We handle all permits, inspections, and compliance requirements so you never have to worry about the details.",
    },
    {
      question: "Can I visit a showroom before committing to a project?",
      answer:
        "Yes! Our Boca Raton showroom at Boca Center (5250 Town Center Cir #109) is open Monday through Friday, 10:00 AM to 5:00 PM, by appointment. Visit us to explore cabinet lines, countertop options, tile selections, and meet our design team.",
    },
  ],
};

const finalCTAContent = {
  badge: "Take The First Step",
  headline: "Your Dream Kitchen",
  headlineAccent: "Starts Here.",
  description:
    "Join hundreds of South Florida homeowners who trusted KRP to transform their most important spaces. Schedule your complimentary consultation today \u2014 no obligation, no pressure.",
  primaryCta: "Get My Free Consultation",
  primaryCtaPath: "/locations",
  secondaryCta: "Call (561) 441-6008",
  secondaryCtaHref: "tel:5614416008",
  backgroundImage:
    "https://readdy.ai/api/search-image?query=breathtaking%20luxury%20kitchen%20transformation%20complete%20dramatic%20reveal%20two%20tone%20cabinetry%20deep%20charcoal%20lower%20white%20upper%20with%20brass%20hardware%20dramatic%20marble%20countertops%20oversized%20pendant%20lights%20professional%20interior%20architectural%20photography%20South%20Florida%20estate%20warm%20golden%20magic%20hour%20cinematic&width=1600&height=1000&seq=4040&orientation=landscape",
};

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection content={heroContent} />
      <TrustBar />
      <ServicesGrid content={servicesContent} />
      <AIAnswerBlock content={aiBlockContent} />
      <ProcessSection content={processContent} />
      <WhyChooseUs content={whyUsContent} />
      <ServiceAreasSection content={areasContent} />
      <TestimonialsSection content={testimonialsContent} />
      <FAQSection content={faqContent} />
      <LeadFormSection variant="light" />
      <FinalCTASection content={finalCTAContent} />
      <Footer />
    </main>
  );
}
